import {lazy} from "react";

export const HelpAsync = lazy(() => import('../ui/Help'))
